import React, { useRef, useEffect, useState } from 'react';
import { Box, Stack, TextareaAutosize, Typography } from '@mui/material';
import { toast } from 'react-toastify';
import { useStyles } from '../styles/descriptionStyles';
import { useProject } from '../../Layout/header/context';
import { updateProject } from '../../../../services/projectService';

const WeeklyTextarea = ({ label, field, placeholder, projectDetails, setProjectDetails, refetchProject }) => {
  const classes = useStyles();
  const [disabled, setDisabled] = useState(false);
  const textareaRef = useRef(null);
  const currentValue = projectDetails?.[field];

  const handleBlur = async (e) => {
    const value = e?.target?.value?.trim();
    if (value === (currentValue ?? '').trim()) return;
    try {
      setDisabled(true);
      await updateProject(projectDetails?.id, { [field]: value });
      setProjectDetails((prev) => ({ ...prev, [field]: value }));
    } catch (error) {
      const errMsg =
        error?.response?.data?.message ||
        'An error occurred while saving. Please try again later.';
      toast.error(errMsg);
      refetchProject();
    } finally {
      setDisabled(false);
    }
  };

  useEffect(() => {
    if (textareaRef.current && textareaRef.current.value !== (currentValue ?? '')) {
      textareaRef.current.value = currentValue ?? '';
    }
  }, [currentValue]);

  return (
    <Stack spacing={1}>
      <Typography variant="h4" color="GrayText">
        {label}
      </Typography>
      <TextareaAutosize
        placeholder={placeholder}
        minRows={3}
        defaultValue={currentValue ?? ''}
        className={classes.projectDescription}
        onBlur={handleBlur}
        ref={textareaRef}
        disabled={disabled}
        style={{
          fontFamily: '"Public Sans", sans-serif',
          fontSize: '16px',
          color: '#333',
        }}
      />
    </Stack>
  );
};

const ProjectWeeklyUpdate = () => {
  const { projectDetails, refetchProject, setProjectDetails } = useProject();

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: { xs: 'column', md: 'row' },
        gap: 3,
      }}
    >
      <Box sx={{ flex: 1, minWidth: 0 }}>
        <WeeklyTextarea
          label="Work Completed This Week"
          field="workCompletedThisWeek"
          placeholder="Summarise the work completed this week..."
          projectDetails={projectDetails}
          setProjectDetails={setProjectDetails}
          refetchProject={refetchProject}
        />
      </Box>
      <Box sx={{ flex: 1, minWidth: 0 }}>
        <WeeklyTextarea
          label="Next Week's Plan"
          field="nextWeekPlan"
          placeholder="Outline the plan for next week..."
          projectDetails={projectDetails}
          setProjectDetails={setProjectDetails}
          refetchProject={refetchProject}
        />
      </Box>
    </Box>
  );
};

export default ProjectWeeklyUpdate;
